import { initializer, inject, injectable } from "@launchtray/tsyringe-async";
import { PromiseCompletionSource, Viewable } from "scene-manager";
import { InjectableInterfaces } from "../../composition/InjectableInterfaces";
import { CommonUIResourcesPackage } from "../common/resources/CommonUIResourcesPackage";
import { ICanvasScaler } from "../../../canvas/ICanvasScaler";
import { SettingsController } from "./controllers/SettingsController";
import { SettingsView } from "./views/SettingsView";
import { SettingsResourcesPackage } from "./resources/SettingsResourcesPackage";
import { Localization } from "../common/Localization";
import { AudioManager } from "../../audio/AudioManager";

@injectable()
export class SettingsScene extends Viewable<void> {
    public constructor(
        @inject(InjectableInterfaces.ICanvasScaler) private readonly canvasScaler: ICanvasScaler,
        private readonly commonUIResources: CommonUIResourcesPackage,
        private readonly settingsResources: SettingsResourcesPackage,
        private readonly settingsController: SettingsController,
        private readonly localization: Localization,
        private readonly audioManager: AudioManager
    ) {
        super();
    }

    @initializer()
    public async initialize(): Promise<void> {
        const sceneCanBeClosed = new PromiseCompletionSource<void>();
        this.view = new SettingsView(
            this.canvasScaler,
            this.commonUIResources,
            this.settingsResources,
            this.settingsController,
            this.localization,
            this.audioManager,
            sceneCanBeClosed
        );
        sceneCanBeClosed.result.then(() => {
            this.operationControls.complete();
        });
    }
}